import { Field, Link as JssLink, RichText, withDatasourceCheck } from "@sitecore-jss/sitecore-jss-nextjs";
import { ComponentProps } from "lib/component-props";
import Image from "next/image";
import {useEffect, useRef} from "react"
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

type YearOfArabicPoetryScholarshipProps = ComponentProps & {
  fields: {
    childItems:[{
      fields:{
        heading: Field<string>;
        Title: Field<string>;
        Description: Field<string>;
        ObjectivesTitle: Field<string>;
        FirstObjective: Field<string>;
        SecondObjective: Field<string>;
        ThirdObjective: Field<string>;
        ResearchScholarshipTitle: Field<string>;
        ApplicationDateText: Field<string>;
        ApplicationDateDescription: Field<string>;
        RelevantAuthoritiesTitle: Field<string>;
        ApplyButtonUrl: any;
        ApplyButtonText: Field<string>;
        SupportDescription: Field<string>;
        SupportTitle: Field<string>;
        Logo: any;
        TermsTitle: Field<string>;
        TermsDescription: any;
        ScholarshipGuideTitle: Field<string>;
        ScholarshipGuideButtonText: Field<string>;
        ManualButtonUrl: any;
        HeroLogoImage: any;
        ObjectivesImageTitle: any;
        TermsImageTitle: any;
        SupportImageTitle: any;
        AuthorityImageTitle: any;
        ResearchScholarshipAreasImageTitle: any;
        AboutImageTitle: any;
        TargetAudienceTitle: Field<string>;
        TargetAudienceDescription: Field<string>;
        TargetAudienceImageTitle: any;
      }
    }]
  };
  locale: any
  lang: string
};
const CircleIcon = (props: any) => {
  return (
    <div className="relative group animate-top">
      <div
        className={`z-20 ${
          props?.isBackgroundHidden ? "" : "absolute"
        } top-0 hover:rotate-180 transition-transform duration-700 ease-in-out`}
      >
        <svg
          className={`${
            props?.isSmall
              ? "w-[40px] h-[40px] md:w-[80px] md:h-[80px]"
              : "w-[50px] h-[51px] h-md:lg:w-[110px] h-md:lg:h-[111px]"
          } `}
          viewBox={`0 0 110 111`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink" aria-hidden={true} focusable="false">
          <path
            d="M54.8042 110.057C40.5434 110.057 27.0752 104.625 16.785 94.7023C6.24534 84.5369 0.300267 70.8779 0.0287018 56.2427C-0.235524 41.6076 5.21781 27.743 15.3758 17.2034C25.5412 6.66367 39.2002 0.71859 53.8354 0.447024C68.4559 0.124081 82.3351 5.63613 92.8748 15.7942C103.414 25.9595 109.36 39.6185 109.631 54.2537C110.174 84.4709 86.0343 109.499 55.8171 110.049C55.4795 110.049 55.1345 110.057 54.7969 110.057H54.8042ZM54.8556 2.65625C54.5253 2.65625 54.2024 2.65624 53.8794 2.66358C39.8314 2.92047 26.7302 8.62336 16.9759 18.7373C7.22152 28.8513 1.99571 42.1507 2.24526 56.1987C2.50214 70.2467 8.20502 83.3479 18.319 93.1023C28.433 102.857 41.8204 108.156 55.7804 107.833C84.7719 107.312 107.936 83.2892 107.407 54.2978C107.15 40.2497 101.44 27.1485 91.3335 17.3942C81.4544 7.86737 68.5366 2.65625 54.8483 2.65625H54.8556Z"
            fill="#1A3B46"
          />
          <g style={{ mixBlendMode: "multiply" }}>
            <mask
              id="mask0_8188_3278"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="10"
              y="13"
              width="90"
              height="84"
            >
              <path
                d="M99.4112 54.4303C99.2571 45.8577 93.2239 38.7896 85.2384 36.9474C87.3522 29.0206 83.9246 20.3819 76.4235 16.235C68.9224 12.0808 59.7846 13.7689 54.1919 19.7653C48.3862 13.9744 39.1897 12.6166 31.8501 17.0424C24.5031 21.4608 21.3985 30.217 23.7912 38.063C15.8717 40.1988 10.1028 47.4797 10.2569 56.0524C10.4111 64.6251 16.4442 71.6931 24.4297 73.5427C22.3159 81.4695 25.7435 90.1082 33.2446 94.2551C40.7457 98.4093 49.8835 96.7212 55.4763 90.7174C61.2819 96.5083 70.4784 97.8662 77.818 93.4404C85.165 89.0219 88.2697 80.2658 85.8769 72.4197C93.7964 70.2839 99.5653 63.003 99.4112 54.4303Z"
                fill="white"
              />
            </mask>
          </g>
          <path
            d="M54.8246 63.3641C59.3079 63.3641 62.9422 59.7297 62.9422 55.2465C62.9422 50.7633 59.3079 47.1289 54.8246 47.1289C50.3414 47.1289 46.707 50.7633 46.707 55.2465C46.707 59.7297 50.3414 63.3641 54.8246 63.3641Z"
            fill="#FE5D79"
          />
          <path
            d="M54.8231 110.065C59.1829 103.855 61.7517 96.2955 61.7517 88.1339C61.7517 79.9722 59.1829 72.4124 54.8231 66.2031C50.4634 72.4124 47.8945 79.9722 47.8945 88.1339C47.8945 96.2955 50.4634 103.855 54.8231 110.065Z"
            fill="#1A3B46"
          />
          <path
            d="M7.34375 82.6505C14.9036 83.3184 22.7276 81.7624 29.7956 77.6816C36.8637 73.6008 42.1262 67.597 45.3262 60.7198C37.7664 60.0518 29.9424 61.6079 22.8744 65.6887C15.8063 69.7695 10.5438 75.7733 7.34375 82.6505Z"
            fill="#1A3B46"
          />
          <path
            d="M7.34375 27.833C10.5438 34.7103 15.8063 40.7141 22.8744 44.7949C29.9424 48.8757 37.7738 50.4317 45.3262 49.7638C42.1262 42.8866 36.8637 36.8828 29.7956 32.8019C22.7276 28.7211 14.8962 27.1651 7.34375 27.833Z"
            fill="#1A3B46"
          />
          <path
            d="M54.8231 0.425781C50.4634 6.63509 47.8945 14.1949 47.8945 22.3565C47.8945 30.5182 50.4634 38.078 54.8231 44.2873C59.1829 38.078 61.7517 30.5182 61.7517 22.3565C61.7517 14.1949 59.1829 6.63509 54.8231 0.425781Z"
            fill="#1A3B46"
          />
          <path
            d="M102.303 27.833C94.743 27.1651 86.919 28.7211 79.8509 32.8019C72.7829 36.8828 67.5204 42.8866 64.3203 49.7638C71.8801 50.4317 79.7041 48.8757 86.7722 44.7949C93.8402 40.7141 99.1027 34.7103 102.303 27.833Z"
            fill="#1A3B46"
          />
          <path
            d="M102.299 82.6622C99.0988 75.785 93.8363 69.7812 86.7683 65.7004C79.7002 61.6196 71.8689 60.0636 64.3164 60.7315C67.5165 67.6087 72.779 73.6125 79.847 77.6933C86.9151 81.7741 94.7464 83.3301 102.299 82.6622Z"
            fill="#1A3B46"
          />
          <defs>
            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
              <use xlinkHref="#image0_8188_3278" transform="scale(0.000206101 0.000319693)" />
            </pattern>
          </defs>
        </svg>
      </div>
      {!props?.isBackgroundHidden && (
        <div
          className={`${
            props?.isSmall
              ? "w-[40px] h-[40px] md:w-[80px] md:h-[80px]"
              : "w-[50px] h-[51px] h-md:lg:w-[110px] h-md:lg:h-[111px]"
          } 
      scale-[.8] md:group-hover:scale-75 transition-transform duration-700 ease-in-out`}
        >
          <Image src="/CulturalYear/yoap-circle.png" loading="eager" layout="fill" alt="Year of Arabic Poetry Scholarship decorative circle" />
        </div>
      )}
    </div>
  );
};

gsap.registerPlugin(ScrollTrigger);

const YearOfArabicPoetryScholarship = (props: YearOfArabicPoetryScholarshipProps): JSX.Element => {
  const guideLinesRef = useRef<HTMLDivElement>(null)
  const applyRef = useRef<HTMLDivElement>(null)
  useEffect(()=>{
    gsap.set(".animate-top", {
      opacity: 0,
      y: 100,
    });
    ScrollTrigger.batch(".animate-top", {
      onEnter: (batch) =>
        gsap.to(batch, {
          opacity: 1,
          y: 0,
          stagger: { each: 0.3 },
          overwrite: true,
          scrollTrigger:{
            trigger: batch,
            start: "top 80%",
            end: "bottom 20%",
            once: true,
            invalidateOnRefresh: true,
          }
        }),
      onEnterBack: (batch) =>
        gsap.to(batch, { opacity: 1, y: 0, stagger: 0.2, overwrite: true }),
    });
    ScrollTrigger.batch(".animate-left", {
      onEnter: (batch) =>
        gsap.to(batch, {
          opacity: 1,
          x:0,
          stagger: { each: 0.3 },
          overwrite: true,
          scrollTrigger:{
            trigger: batch,
            start: "top 50%",
            end: "bottom 20%",
            once: true,
            invalidateOnRefresh: true,
          }
        }),
      onEnterBack: (batch) =>
        gsap.to(batch, { opacity: 1, y: 0, stagger: 0.2, overwrite: true }),
    });
    ScrollTrigger.batch(".animate-right", {
      onEnter: (batch) =>
        gsap.to(batch, {
          opacity: 1,
          x: 0,
          delay: 0.4,
          stagger: { each: 0.5 },
          overwrite: true,
          scrollTrigger:{
            trigger: batch,
            start: "top 50%",
            end: "bottom 20%",
            once: true,
          }
        }),
      onEnterBack: (batch) =>
        gsap.to(batch, { opacity: 1, y: 0, stagger: 0.4, overwrite: true }),
    });
    ScrollTrigger.batch(".fadeIn", {
      onEnter: (batch) =>
        gsap.to(batch, {
          opacity:1,
          stagger: { each: 0.5 },
          overwrite: true,
          scrollTrigger:{
            trigger: batch,
            start: "top 50%",
            end: "bottom 20%",
            // once: true,
          }
        }),
      onEnterBack: (batch) =>
        gsap.to(batch, { opacity: 1, y: 0, stagger: 0.4, overwrite: true }),
    });
  }, [])
  const headersStyle = "font-bold text-title-3brand text-start animate-top";
  const pStyle = "leading-normal font-normal text-[14px] sm:text-[16px] md:text-[28px]";
  return (
    <>
      <div className="min-h-screen bg-[#f9f4e0] text-brand-100">
        <section className={`responsive top-0 pt-[10.125rem] font-medium mb-[0.938rem] h-md:mb-[1.938rem] text-xs md:text-base lg:text-[18px]
            ${props?.locale == props?.lang ? "rtl":""}`}>
            <div className="w-full flex justify-end gap-10 mb-[0.5rem] h-md:mb-[1rem]">
              <div className="group">
                <div className="cursor-pointer" onClick={()=>{
                  applyRef.current?.scrollIntoView({behavior: "smooth"})
                }}>{props?.locale == props?.lang ? "الأدلة التوجيهية":"GRANT APPLICATION"}</div>
                <div className="h-[2px] bg-[#1A3B46] w-0 transition-all duration-700 ease-in-out group-hover:w-full" />
              </div>
              <div className="group">
                <div className="cursor-pointer" onClick={()=>{
                  guideLinesRef.current?.scrollIntoView({behavior: "smooth"})
                }}>{props?.locale == props?.lang ? "منح الأبحاث":"GUIDELINES"}</div>
                <div className="h-[2px] bg-[#1A3B46] w-0 transition-all duration-700 ease-in-out group-hover:w-full" />
              </div>
            </div>
            <div className="flex items-center justify-between md:max-w-[85%] m-0 mx-auto">
              <CircleIcon isBackgroundHidden={true} />
              {props?.fields?.childItems[0]?.fields?.HeroLogoImage?.value?.src && <div className="relative max-w-[50%] md:max-w-full">
                <Image 
                  src={props?.fields?.childItems[0]?.fields?.HeroLogoImage?.value?.src}  alt={props?.fields?.childItems[0]?.fields?.HeroLogoImage?.value?.alt || "Scholarship hero logo"}
                  width={"430px"}
                  height={"200px"}
                  objectFit="contain"
                />
              </div>}
              <CircleIcon isBackgroundHidden={true} />
            </div>
        </section>
        <section className="w-full h-full pb-[10.125rem]">
          <div className="relative h-[350px] sm:h-[500px] md:h-[800px] h-md:md:h-[1200px] w-screen animate-top">
            <Image
              src="/CulturalYear/Scholarship/Hero.png"  alt="Year of Arabic Poetry Scholarship hero image"
              layout="fill"
              loading="eager"
              className="object-contain xl:object-cover h-md:xl:object-contain"
            />
          </div>
        </section>
        <section className="responsive pb-[55px] md:pb-[104px]">
          <div className="flex gap-4 md:gap-20 justify-center pb-[60px]">
            <CircleIcon isSmall={true} />
            <CircleIcon isSmall={true} />
            <CircleIcon isSmall={true} />
          </div>
          <div>
            {props?.fields?.childItems[0]?.fields?.Title?.value && <h2 className={`${headersStyle} mb-[46px]`}>{props?.fields?.childItems[0]?.fields?.Title?.value}</h2>}
            {props?.fields?.childItems[0]?.fields?.AboutImageTitle?.value?.src && <div className="relative text-center animate-top">
                <Image 
                  src={props?.fields?.childItems[0]?.fields?.AboutImageTitle?.value?.src}  alt={props?.fields?.childItems[0]?.fields?.AboutImageTitle?.value?.alt || "About section title image"}
                  width={"480px"}
                  height={"150px"}
                  objectFit="contain"
                />
              </div>}
            <div className={`animate-top text-justify ${pStyle}`}>
              <RichText field={props?.fields?.childItems[0]?.fields?.Description} />
            </div>
          </div>
        </section>
        <section className="responsive max-w-[90%] m-0 mx-auto pb-[102px] lg:pb-[204px]">
          <div className="relative flex items-center justify-between mb-10 md:justify-center md:gap-24">
            <div className="w-[26%] md:w-[20%] animate-right -translate-x-[100px] opacity-0">
              <Image
                src="/CulturalYear/red-bird.png"  alt="Decorative red bird illustration"
                layout="responsive"
                width={"257px"}
                height={"189px"}
                loading="eager"
              />
            </div>
            {props?.fields?.childItems[0]?.fields?.ObjectivesTitle?.value&&<h2 className={`${headersStyle} animate-top translate-y-[100px]`}>
              {props?.fields?.childItems[0]?.fields?.ObjectivesTitle?.value}
            </h2>}
            {props?.fields?.childItems[0]?.fields?.ObjectivesImageTitle?.value?.src && <div className="relative animate-top max-w-[70%] md:max-w-full">
                <Image 
                  src={props?.fields?.childItems[0]?.fields?.ObjectivesImageTitle?.value?.src}  alt={props?.fields?.childItems[0]?.fields?.ObjectivesImageTitle?.value?.alt || "Objectives section title image"}
                  width={"480px"}
                  height={"150px"}
                  objectFit="contain"
                />
              </div>}
            <div className="w-[28%] md:w-[22%] animate-left translate-x-[100px] opacity-0">
              <Image
                src="/CulturalYear/yellow-bird.png"  alt="Decorative yellow bird illustration"
                layout="responsive"
                width={"257px"}
                height={"189px"}
                loading="eager"
              />
            </div>
          </div>
          <div
            className={`grid gap-4 md:grid-cols-3 md:gap-[3.375rem] ${
              props?.locale == props?.lang ? "rtl" : ""
            }`}
          >
            <div className="bg-[#F9EFD7] flex flex-col items-center gap-[2.938rem] py-[3.625rem] px-[1rem] animate-top">
              <div>
                <CircleIcon isSmall={true} />
              </div>
              <div>
                <h3
                  className={`text-[14px] md:text-[16px] lg:text-[21px] font-normal ${
                    props?.locale == props?.lang ? "rtl" : ""
                  }`}
                >
                  {props?.fields?.childItems[0]?.fields?.FirstObjective?.value}
                </h3>
              </div>
            </div>
            <div className="bg-[#F9EFD7] flex flex-col items-center gap-[2.938rem] py-[3.625rem] px-[1rem] animate-top">
              <div>
                <CircleIcon isSmall={true} />
              </div>
              <div>
                <h3
                  className={`text-[14px] md:text-[16px] lg:text-[21px] font-normal ${
                    props?.locale == props?.lang ? "rtl" : ""
                  }`}
                >
                  {props?.fields?.childItems[0]?.fields?.SecondObjective?.value}
                </h3>
              </div>
            </div>
            <div className="bg-[#F9EFD7] flex flex-col items-center gap-[2.938rem] py-[3.625rem] px-[1rem] animate-top">
              <div>
                <CircleIcon isSmall={true} />
              </div>
              <div>
                <h3
                  className={`text-[14px] md:text-[16px] lg:text-[21px] font-normal ${
                    props?.locale == props?.lang ? "rtl" : ""
                  }`}
                >
                  {props?.fields?.childItems[0]?.fields?.ThirdObjective?.value}
                </h3>
              </div>
            </div>
          </div>
        </section>
        <section className="relative overflow-y-hidden pb-[102px] lg:pb-[204px] overflow-hidden">
          <div className="absolute top-0 z-0 w-full">
            <svg 
              width="100%" // Set width to 100% for responsiveness
              height="auto" // Set height to auto to maintain aspect ratio
              viewBox="0 0 1440 683"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-full" aria-hidden={true} focusable="false">
              <path d="M1021.28 115.226C823.573 72.5143 738.724 63.3933 470.103 64.8871C201.483 66.3809 -8.58574 -0.988488 -34.8831 0.0349825C-34.844 1.72337 -40.7555 682.846 -34.8831 682.846C-29.0107 682.846 1474.3 677.045 1474.3 677.045V145.166C1474.3 145.166 1219 157.939 1021.28 115.226Z" fill="url(#paint0_linear_8298_3499)">
              <animate attributeName="d" fill="freeze" dur="20.5s" begin="0s"  repeatCount="indefinite" values="M1021.28 115.226C823.573 72.5143 738.724 63.3933 470.103 64.8871C201.483 66.3809 -8.58574 -0.988488 -34.8831 0.0349825C-34.844 1.72337 -40.7555 682.846 -34.8831 682.846C-29.0107 682.846 1474.3 677.045 1474.3 677.045V145.166C1474.3 145.166 1219 157.939 1021.28 115.226Z;
              M1021.28,115.226C823.573,72.5143,719.999999,74.92408,470.102999,74.92408C201.482999,76.41788,-8.58574,-0.988488,-34.8831,0.034983C-34.844,1.72337,-40.7555,682.846,-34.8831,682.846C-29.0107,682.846,1474.3,677.045,1474.3,677.045L1474.3,145.166C1474.3,145.166,1219,157.939,1021.28,115.226Z;
              M1021.28,115.226C823.573,72.5143,719.999999,84.96106,470.102999,84.96106C201.482999,86.45486,-8.58574,-0.988488,-34.8831,0.034983C-34.844,1.72337,-40.7555,682.846,-34.8831,682.846C-29.0107,682.846,1474.3,677.045,1474.3,677.045L1474.3,145.166C1474.3,145.166,1219,157.939,1021.28,115.226Z;
              M1021.28,115.226C823.573,72.5143,719.999998,94.99804,470.102998,94.99804C201.482998,96.49184,-8.58574,-0.988488,-34.8831,0.034983C-34.844,1.72337,-40.7555,682.846,-34.8831,682.846C-29.0107,682.846,1474.3,677.045,1474.3,677.045L1474.3,145.166C1474.3,145.166,1219,157.939,1021.28,115.226Z;
              M1021.28,115.226C823.573,72.5143,719.999998,105.03502,470.102998,105.03502C201.482998,106.52882,-8.58574,-0.988488,-34.8831,0.034983C-34.844,1.72337,-40.7555,682.846,-34.8831,682.846C-29.0107,682.846,1474.3,677.045,1474.3,677.045L1474.3,145.166C1474.3,145.166,1219,157.939,1021.28,115.226Z;
              M1021.28,115.226C823.573,72.5143,719.999997,115.072,470.102997,115.072C201.482997,116.5658,-8.58574,-0.988488,-34.8831,0.034983C-34.844,1.72337,-40.7555,682.846,-34.8831,682.846C-29.0107,682.846,1474.3,677.045,1474.3,677.045L1474.3,145.166C1474.3,145.166,1219,157.939,1021.28,115.226Z;
              M1026.477544,108.279031C828.770544,65.567331,719.999997,115.072,470.102997,115.072C201.482997,116.5658,-8.58574,-0.988488,-34.8831,0.034983C-34.844,1.72337,-40.7555,682.846,-34.8831,682.846C-29.0107,682.846,1474.3,677.045,1474.3,677.045L1474.3,145.166C1474.3,145.166,1224.197544,150.992031,1026.477544,108.279031Z;
              M1031.675089,101.332061C833.968089,58.620361,719.999997,115.072,470.102997,115.072C201.482997,116.5658,-8.58574,-0.988488,-34.8831,0.034983C-34.844,1.72337,-40.7555,682.846,-34.8831,682.846C-29.0107,682.846,1474.3,677.045,1474.3,677.045L1474.3,145.166C1474.3,145.166,1229.395089,144.045061,1031.675089,101.332061Z;
              M1036.872633,94.385092C839.165633,51.673392,719.999997,115.072,470.102997,115.072C201.482997,116.5658,-8.58574,-0.988488,-34.8831,0.034983C-34.844,1.72337,-40.7555,682.846,-34.8831,682.846C-29.0107,682.846,1474.3,677.045,1474.3,677.045L1474.3,145.166C1474.3,145.166,1234.592633,137.098092,1036.872633,94.385092Z;
              M1035.964689,104.728546C838.257689,62.016846,719.999997,89.90255,470.102997,89.90255C201.482997,91.39635,-8.58574,-0.988488,-34.8831,0.034983C-34.844,1.72337,-40.7555,682.846,-34.8831,682.846C-29.0107,682.846,1474.3,677.045,1474.3,677.045L1474.3,145.166C1474.3,145.166,1233.684689,147.441546,1035.964689,104.728546Z;
              M1035.056744,115.072C837.349744,72.3603,719.999997,64.7331,470.102997,64.7331C201.482997,66.2269,-8.58574,-0.988488,-34.8831,0.034983C-34.844,1.72337,-40.7555,682.846,-34.8831,682.846C-29.0107,682.846,1474.3,677.045,1474.3,677.045L1474.3,145.166C1474.3,145.166,1232.776744,157.785,1035.056744,115.072Z;
              M1021.28,115.226C823.573,72.5143,720,64.8871,470.103,64.8871C201.483,66.3809,-8.58574,-0.988488,-34.8831,0.034983C-34.844,1.72337,-40.7555,682.846,-34.8831,682.846C-29.0107,682.846,1474.3,677.045,1474.3,677.045L1474.3,145.166C1474.3,145.166,1219,157.939,1021.28,115.226Z;
              M1021.28,115.226C823.573,72.5143,720,64.8871,470.103,64.8871C201.483,66.3809,-8.58574,-0.988488,-34.8831,0.034983C-34.844,1.72337,-40.7555,682.846,-34.8831,682.846C-29.0107,682.846,1474.3,677.045,1474.3,677.045L1474.3,145.166C1474.3,145.166,1219,157.939,1021.28,115.226Z;
              M1021.28 115.226C823.573 72.5143 738.724 63.3933 470.103 64.8871C201.483 66.3809 -8.58574 -0.988488 -34.8831 0.0349825C-34.844 1.72337 -40.7555 682.846 -34.8831 682.846C-29.0107 682.846 1474.3 677.045 1474.3 677.045V145.166C1474.3 145.166 1219 157.939 1021.28 115.226Z"
              />
              </path>

              <defs>
              <linearGradient id="paint0_linear_8298_3499" x1="812.138" y1="0.023442" x2="969.852" y2="744.626" gradientUnits="userSpaceOnUse">
              <stop stop-color="#F2E9D4"/>
              <stop offset="1" stop-color="#FAF4DE" stop-opacity="0"/>
              </linearGradient>
              </defs>
            </svg>
          </div>
          <div className="responsive z-30 relative">
              {props?.fields?.childItems[0]?.fields?.ResearchScholarshipTitle?.value&&<h2 className={`${headersStyle} pb-[86.5px] lg:pb-[173px] z-10`}>
                {props?.fields?.childItems[0]?.fields?.ResearchScholarshipTitle?.value}
              </h2>}
              {props?.fields?.childItems[0]?.fields?.ResearchScholarshipAreasImageTitle?.value?.src && <div className="relative text-center pb-[86.5px] lg:pb-[173px] animate-top">
                <Image 
                  src={props?.fields?.childItems[0]?.fields?.ResearchScholarshipAreasImageTitle?.value?.src}  alt={props?.fields?.childItems[0]?.fields?.ResearchScholarshipAreasImageTitle?.value?.alt || "Research scholarship areas title image"}
                  width={"480px"}
                  height={"150px"}
                  objectFit="contain"
                />
              </div>}
              <div className="flex flex-col gap-y-4">
                {props?.fields?.childItems?.map((item:any, index:number)=>{
                  if(index == 0){
                    return
                  }
                  return (
                    <div className={`md:w-full animate-top ${index % 2 == 0 ? "self-end":"self-start"} 
                    ${props?.locale == props?.lang ? "rtl":""}`} key={index}>
                      <div className={`relative flex flex-col lg:justify-end ${index % 2 == 0 ? "lg:flex-row animate-right":"lg:flex-row-reverse animate-left"}`}>
                        {item?.fields?.Image?.value?.src &&
                        <div className="md:top-[-26vh] xl:top-[-27vh] lg:w-1/2 flex justify-center items-center">
                          <div className="relative w-full flex justify-center items-center">
                            <img 
                              src={item?.fields?.Image?.value?.src}  alt={item?.fields?.Image?.value?.alt || item?.fields?.Title?.value || "Research area image"}
                              className={`"w-full ${item?.fields?.Image?.value?.src.includes("bird") ? "h-[100px] lg:h-[130px]":"h-[200px] lg:h-[300px]"} object-contain`}
                              />
                          </div>
                        </div>}
                        <div className="z-30 relative lg:w-1/2 bg-[#F6EFD7] p-2 lg:p-7">
                          <h3 className="text-base sm:text-[18px] lg:text-[25px] font-bold leading-8 mb-4">{item?.fields?.Title?.value}</h3>
                          <div className="text-justify animate-top text-[14px] md:text-[16px] lg:text-[21px] font-normal">
                            <RichText 
                              field={item?.fields?.Description}
                              />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) 
                })}
              </div>
          </div>
        </section>
        <section className="relative overflow-visible">
        <img src="/CulturalYear/Scholarship/image221-min.png"  alt="Year of Arabic Poetry Scholarship decorative image" className="object-contain absolute top-[-13rem] right-0 z-20 w-[380px] h-[460px] fadeIn opacity-0 hidden xl:block" />
          <div className="absolute top-[3vh] z-0 w-full">
            <svg width="100%" height="auto" viewBox="0 0 1440 657" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" aria-hidden={true} focusable="false">
              <path opacity="0.903" d="M1460.31 647.155C1466.3 623.236 1857.79 381.477 1437.97 208.059C1018.15 34.6406 636.943 123.728 274.735 11.6923C-87.473 -100.343 -635.396 639.3 -635.396 639.3C-635.396 639.3 1454.32 671.073 1460.31 647.155Z" fill="url(#paint0_linear_8298_3492)"
              >
                <animate attributeName="d" dur="10.5s" begin="0s" repeatCount="indefinite" values="M1460.31 647.155C1466.3 623.236 1857.79 381.477 1437.97 208.059C1018.15 34.6406 636.943 123.728 274.735 11.6923C-87.473 -100.343 -635.396 639.3 -635.396 639.3C-635.396 639.3 1454.32 671.073 1460.31 647.155Z;
                M1460.31,647.155C1466.3,623.236,1844.494484,411.470832,1437.97,208.059C1035.098673,7.990302,622.381887,143.572631,274.735,11.6923C-76.277058,-122.644229,-635.396,639.3,-635.396,639.3C-635.396,639.3,1454.32,671.073,1460.31,647.155Z;
                M1460.31,647.155C1466.3,623.236,1831.198969,441.464665,1437.97,208.059C1052.047346,-18.659996,607.820774,163.417262,274.735,11.6923C-65.081116,-144.945458,-635.396,639.3,-635.396,639.3C-635.396,639.3,1454.32,671.073,1460.31,647.155Z;
                M1460.31,647.155C1466.3,623.236,1817.903453,471.458497,1437.97,208.059C1068.99602,-45.310294,593.25966,183.261894,274.735,11.6923C-53.885175,-167.246688,-635.396,639.3,-635.396,639.3C-635.396,639.3,1454.32,671.073,1460.31,647.155Z;
                M1460.31,647.155C1466.3,623.236,1804.607938,501.45233,1437.97,208.059C1085.944693,-71.960592,578.698547,203.106525,274.735,11.6923C-42.689233,-189.547917,-635.396,639.3,-635.396,639.3C-635.396,639.3,1454.32,671.073,1460.31,647.155Z;
                M1460.31,647.155C1466.3,623.236,1791.312422,531.446162,1437.97,208.059C1102.893366,-98.61089,564.137434,222.951156,274.735,11.6923C-31.493291,-211.849146,-635.396,639.3,-635.396,639.3C-635.396,639.3,1454.32,671.073,1460.31,647.155Z;
                M1460.31,647.155C1466.3,623.236,1802.200481,497.420977,1437.97,208.059C1084.87089,-69.237558,573.210817,196.184677,274.735,11.6923C-44.12529,-184.227504,-635.396,639.3,-635.396,639.3C-635.396,639.3,1454.32,671.073,1460.31,647.155Z;
                M1460.31,647.155C1466.3,623.236,1813.08854,463.395793,1437.97,208.059C1066.848415,-39.864226,582.284199,169.418199,274.735,11.6923C-56.757288,-156.605862,-635.396,639.3,-635.396,639.3C-635.396,639.3,1454.32,671.073,1460.31,647.155Z;
                M1460.31,647.155C1466.3,623.236,1823.976599,429.370608,1437.97,208.059C1048.825939,-10.490893,591.357582,142.65172,274.735,11.6923C-69.389287,-128.984219,-635.396,639.3,-635.396,639.3C-635.396,639.3,1454.32,671.073,1460.31,647.155Z;
                M1460.31,647.155C1466.3,623.236,1834.864658,395.345424,1437.97,208.059C1030.803464,18.882439,600.430964,115.885242,274.735,11.6923C-82.021285,-101.362577,-635.396,639.3,-635.396,639.3C-635.396,639.3,1454.32,671.073,1460.31,647.155Z;
                M1460.31,647.155C1466.3,623.236,1845.752717,361.320239,1437.97,208.059C1012.780988,48.255771,609.504347,89.118763,274.735,11.6923C-94.653284,-73.740935,-635.396,639.3,-635.396,639.3C-635.396,639.3,1454.32,671.073,1460.31,647.155Z;
                M1460.31,647.155C1466.3,623.236,1857.79,381.477,1437.97,208.059C1018.15,34.6406,636.943,123.728,274.735,11.6923C-87.473,-100.343,-635.396,639.3,-635.396,639.3C-635.396,639.3,1454.32,671.073,1460.31,647.155Z;
                M1460.31,647.155C1466.3,623.236,1857.79,381.477,1437.97,208.059C1018.15,34.6406,636.943,123.728,274.735,11.6923C-87.473,-100.343,-635.396,639.3,-635.396,639.3C-635.396,639.3,1454.32,671.073,1460.31,647.155Z" />
              </path>
              <defs>
              <linearGradient id="paint0_linear_8298_3492" x1="827.827" y1="-102.985" x2="270.191" y2="999.506" gradientUnits="userSpaceOnUse">
              <stop stop-color="#F2E9D4"/>
              <stop offset="1" stop-color="#FAF4DE" stop-opacity="0"/>
              </linearGradient>
              </defs>
              </svg>
          </div>
          <div className="absolute top-12 z-[1] w-full">
            <svg width="100%" height="auto" viewBox="0 0 1440 906" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" aria-hidden={true} focusable="false">
              <path d="M-13.259 115.641C-13.259 115.641 134.852 153.724 332.562 94.1786C530.273 34.6332 697.093 -36.6006 993.119 21.8871C1289.15 80.3747 1444.26 42.0703 1470.55 43.4963C1496.85 44.9223 1545.93 157.689 1545.93 157.689C1545.93 157.689 1507.94 905.347 1502.07 905.347C1496.2 905.347 -49.7422 893.576 -49.7422 893.576L-35.8099 115.641H-13.259Z" fill="url(#paint0_linear_8298_3493)">
                </path>
              <defs>
              <linearGradient id="paint0_linear_8298_3493" x1="-49.7422" y1="0.0859375" x2="755.471" y2="1325.73" gradientUnits="userSpaceOnUse">
              <stop stop-color="#F2E9D4"/>
              <stop offset="1" stop-color="#FAF4DE" stop-opacity="0"/>
              </linearGradient>
              </defs>
            </svg>
          </div>
          <div className={`responsive ${headersStyle} pb-[102px] pt-40 relative z-10`}>
            <div className="flex gap-6 lg:gap-32 justify-center pb-[60px]">
              <CircleIcon isSmall={true} />
              <CircleIcon isSmall={true} />
              <CircleIcon isSmall={true} />
            </div>
            <div>
              <div className={`${props?.locale == props?.lang ? "rtl":""}`}>
                <h3 className={`${pStyle} !font-bold`}>
                  {props?.fields?.childItems[0]?.fields?.ApplicationDateText?.value}
                </h3>
                <h4 className="text-[14px] md:text-[16px] lg:text-[21px] font-normal">
                  {props?.fields?.childItems[0]?.fields?.ApplicationDateDescription?.value}
                </h4>
              </div>
              <div className={`flex justify-between flex-col lg:flex-row gap-6 lg:gap-0 
              ${props?.locale == props?.lang ? "rtl":""}`}>
                <div className="lg:w-1/2" ref={applyRef}>
                  {props?.fields?.childItems[0]?.fields?.SupportTitle?.value && <h2 className={`mb-[5px] md:mb-[16px] ${headersStyle}`}>{props?.fields?.childItems[0]?.fields?.SupportTitle?.value}</h2>}
                  {props?.fields?.childItems[0]?.fields?.SupportImageTitle?.value?.src && <div className="relative text-center mb-[5px] md:mb-[16px] animate-top">
                    <Image 
                      src={props?.fields?.childItems[0]?.fields?.SupportImageTitle?.value?.src}  alt={props?.fields?.childItems[0]?.fields?.SupportImageTitle?.value?.alt || "Support section title image"}
                      width={"480px"}
                      height={"100px"}
                      objectFit="contain"
                    />
                  </div>}
                  <p className={`${pStyle} mb-[60px] animate-top`}>{props?.fields?.childItems[0]?.fields?.SupportDescription?.value}</p>
                  <div>
                  {props?.fields?.childItems[0]?.fields?.TargetAudienceTitle?.value && <h2 className={`mb-[5px] md:mb-[16px] ${headersStyle}`}>{props?.fields?.childItems[0]?.fields?.TargetAudienceTitle?.value}</h2>}
                  {props?.fields?.childItems[0]?.fields?.TargetAudienceImageTitle?.value?.src && <div className="relative text-center mb-[5px] md:mb-[16px] animate-top">
                    <Image 
                      src={props?.fields?.childItems[0]?.fields?.TargetAudienceImageTitle?.value?.src}  alt={props?.fields?.childItems[0]?.fields?.TargetAudienceImageTitle?.value?.alt || "Target audience section title image"}
                      width={"480px"}
                      height={"100px"}
                      objectFit="contain"
                    />
                  </div>}
                  <p className={`${pStyle} mb-[60px] animate-top`}>{props?.fields?.childItems[0]?.fields?.TargetAudienceDescription?.value}</p>
                  </div>
                  <JssLink field={props?.fields?.childItems[0]?.fields?.ApplyButtonUrl} >
                    <button className="bg-[#B41932] text-white px-4 py-2 text-sm md:text-base lg:text-[18px] font-normal animate-top" >{props?.fields?.childItems[0]?.fields?.ApplyButtonText?.value}</button>
                  </JssLink>
                </div>
                <div>
                  {props?.fields?.childItems[0]?.fields?.RelevantAuthoritiesTitle?.value && <h2 className={`mb-[5px] md:mb-[16px] ${headersStyle}`}>{props?.fields?.childItems[0]?.fields?.RelevantAuthoritiesTitle?.value}</h2>}                  
                  {props?.fields?.childItems[0]?.fields?.AuthorityImageTitle?.value?.src && <div className="relative text-center mb-[5px] md:mb-[16px] animate-top">
                      <Image 
                        src={props?.fields?.childItems[0]?.fields?.AuthorityImageTitle?.value?.src}  alt={props?.fields?.childItems[0]?.fields?.AuthorityImageTitle?.value?.alt || "Authority section title image"}
                        width={"480px"}
                        height={"100px"}
                        objectFit="contain"
                      />
                  </div>}
                  <div className={`relative animate-top text-center sm:text-start ${props?.locale == props?.lang ? "text-center":""}`}>
                    <Image 
                      src={props?.fields?.childItems[0]?.fields?.Logo?.value?.src}  alt={props?.fields?.childItems[0]?.fields?.Logo?.value?.alt || "Scholarship logo"}
                      width={"374px"}
                      height={"147px"}
                      />
                    </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="relative pt-[51] lg:pt-[102px] pb-[102px] lg:pb-[204px] overflow-hidden">
          <div className="absolute top-0 right-0 z-10 w-[120px] h-[130px] sm:w-[170px] sm:h-[180px] md:w-[270px] md:h-[280px] fadeIn opacity-0 hidden lg:block">
            <Image src="/CulturalYear/Scholarship/horse.png" layout="fill" loading="eager"  alt="Decorative horse illustration" />
          </div>
          <div className="absolute left-[-7vw] lg:lef z-10 w-[120px] h-[130px] sm:w-[170px] sm:h-[180px] md:w-[270px] md:h-[480px] lg:w-[470px] lg:h-[530px] fadeIn opacity-0">
            <Image src="/CulturalYear/tree.png"  alt="Decorative tree illustration" layout="fill" loading="eager" objectFit="contain" />
          </div>
          <div className="absolute right-[-5vw] lg:right-[-10vw] bottom-0 lg:bottom-[10vh] w-[120px] h-[130px] sm:w-[170px] sm:h-[180px] md:w-[270px] md:h-[280px] lg:w-[470px] lg:h-[530px] fadeIn opacity-0" style={{transform: "rotateY(180deg)"}}>
            <Image src="/CulturalYear/tree.png"  alt="Decorative tree illustration" layout="fill" loading="eager" objectFit="contain" />
          </div>
          <div className="absolute top-0 z-0 w-full">
            <svg width="100%" height="auto" viewBox="0 0 1440 953" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" aria-hidden={true} focusable="false">
              <path d="M1017.85 160.854C820.998 101.309 736.517 88.5939 469.059 90.6759C201.602 92.7579 -7.55535 -1.15992 -33.7381 0.266077C-33.6992 2.61939 -39.5851 952.159 -33.7381 952.159C-27.8911 952.159 1468.91 944.072 1468.91 944.072V202.592C1468.91 202.592 1214.71 220.4 1017.85 160.854Z" fill="url(#paint0_linear_8298_3495)"/>
              <defs>
              <linearGradient id="paint0_linear_8298_3495" x1="-36.3281" y1="0.25" x2="401.866" y2="636.711" gradientUnits="userSpaceOnUse">
              <stop stop-color="#F2E9D4"/>
              <stop offset="1" stop-color="#FAF4DE" stop-opacity="0"/>
              </linearGradient>
              </defs>
            </svg>
          </div>
          <div className="absolute top-[50%] z-[2] w-full">
          <svg width="100%" height="auto" viewBox="0 0 1440 957" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" aria-hidden={true} focusable="false">
            <path d="M1458.84 62.8574C1458.84 62.8574 1313.72 111.156 1112.2 65.4676C910.687 19.7793 739.177 -39.7204 447.867 39.2199C156.557 118.16 -0.943673 90.7102 -27.0864 93.9605C-53.229 97.2109 -94.265 213.163 -94.265 213.163C-94.265 213.163 -3.62798 956.686 2.23266 956.278C8.09331 955.87 1550.11 836.701 1550.11 836.701L1481.35 61.2904L1458.84 62.8574Z" fill="url(#paint0_linear_8298_3497)"/>
            <defs>
            <linearGradient id="paint0_linear_8298_3497" x1="-105.379" y1="55.875" x2="304.938" y2="762.09" gradientUnits="userSpaceOnUse">
            <stop stop-color="#F2E9D4"/>
            <stop offset="1" stop-color="#FAF4DE" stop-opacity="0"/>
            </linearGradient>
            </defs>
          </svg>
          </div>
          <div className="responsive overflow-y-hidden relative z-10 px-[124px] max-w-[1440px] m-0 mx-auto">
            {props?.fields?.childItems[0]?.fields?.TermsTitle?.value && <h2 className={`${headersStyle} pb-[60px]`}>
              {props?.fields?.childItems[0]?.fields?.TermsTitle?.value}
            </h2>}
            {props?.fields?.childItems[0]?.fields?.TermsImageTitle?.value?.src && <div className="relative text-center pb-[60px] animate-top">
                <Image 
                  src={props?.fields?.childItems[0]?.fields?.TermsImageTitle?.value?.src}  alt={props?.fields?.childItems[0]?.fields?.TermsImageTitle?.value?.alt || "Terms section title image"}
                  width={"480px"}
                  height={"150px"}
                  objectFit="contain"
                />
              </div>}
            <div className={`custom-yoap-list relative lg:w-[80%] animate-top text-justify ${props?.locale == props?.lang ? "rtl":""}`}>
              <RichText 
                field={props?.fields?.childItems[0]?.fields?.TermsDescription}
              />
            </div>
          </div>
        </section>
        <section className={`relative overflow-y-hidden ${props?.locale == props?.lang ? "rtl":""}`}>
          <div className="absolute top-[3vh] z-0 w-full">
          <svg width="100%" height="auto" viewBox="0 0 1440 882" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" aria-hidden={true} focusable="false">
            <path d="M442.665 44.8562C648.189 23.8525 733.925 27.4427 997.208 80.3646C1260.49 133.286 1484.75 80.8823 1510.29 87.2637C1509.8 89.5664 1333.09 1022.78 1327.32 1021.67C1321.56 1020.56 -152.579 727.88 -152.579 727.88L-10.0507 0.0229431C-10.0507 0.0229431 237.142 65.86 442.665 44.8562Z" fill="url(#paint0_linear_8298_3498)"/>
            <defs>
            <linearGradient id="paint0_linear_8298_3498" x1="13.1077" y1="-118.241" x2="400.597" y2="544.584" gradientUnits="userSpaceOnUse">
            <stop stop-color="#F2E9D4"/>
            <stop offset="1" stop-color="#FAF4DE" stop-opacity="0"/>
            </linearGradient>
            </defs>
          </svg>
          </div>
          <div className="responsive z-10 pb-[154px] relative" ref={guideLinesRef}>
            <h2 className={`mb-[5px] md:mb-[16px] ${headersStyle}`}>{props?.fields?.childItems[0]?.fields?.ScholarshipGuideTitle?.value}</h2>
            {props?.fields?.childItems[0]?.fields?.ManualButtonUrl?.value?.href ? (
              <a href={props.fields.childItems[0].fields.ManualButtonUrl.value.href} download>
                <button className="bg-[#B41932] text-white px-4 py-2 text-sm md:text-base lg:text-[18px] font-normal animate-top">{props?.fields?.childItems[0]?.fields?.ScholarshipGuideButtonText?.value}</button>
              </a>
            ) : (
              <button className="bg-[#B41932] text-white px-4 py-2 text-sm md:text-base lg:text-[18px] font-normal animate-top opacity-60 cursor-not-allowed" disabled>{props?.fields?.childItems[0]?.fields?.ScholarshipGuideButtonText?.value}</button>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default withDatasourceCheck()<YearOfArabicPoetryScholarshipProps>(
  YearOfArabicPoetryScholarship
);
